import { render, staticRenderFns } from "./JSelectBizComponentModal.vue?vue&type=template&id=c23c2ace&scoped=true"
import script from "./JSelectBizComponentModal.vue?vue&type=script&lang=js"
export * from "./JSelectBizComponentModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectBizComponentModal.vue?vue&type=style&index=0&id=c23c2ace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23c2ace",
  null
  
)

export default component.exports